export default "__VITE_ASSET__CYZ2zC9N__"